import ClaimDetailsScreen from '../components/ClaimDetailsScreen';
import PolicyDetailScreen from '../components/PolicyDetailScreen';
import PersonalInfoScreen from '../components/PersonalInfoScreen';
import DocumentationScreen from '../components/DocumentationScreen';
import VehicleScreen from '../components/VehicleScreen';
import ConfirmationScreen from '../components/ConfirmationScreen';
import { translations } from './consts';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: PolicyDetailScreen,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: ClaimDetailsScreen,
        step: 1,
        label: translations.stepLabel.DETAILS,
    },

    {
        path: '/stepThree',
        screen: PersonalInfoScreen,
        step: 2,
        label: translations.stepLabel.PERSONS,
    },

    {
        path: '/stepFour',
        screen: VehicleScreen,
        step: 3,
        label: translations.stepLabel.VEHICLE,
    },

    {
        path: '/stepFive',
        screen: DocumentationScreen,
        step: 4,
        label: translations.stepLabel.DOCUMENTATION,
    },

    {
        path: '/stepSix',
        screen: ConfirmationScreen,
        step: 5,
        label: translations.stepLabel.CONFIRMATION,
    },
];

export default stepsComposer;
